/*
 * np-offer-cta.js — mobile above-the-fold buy CTA for offer cells B-E.
 * Built 2026-09-01 (Jared screenshot report: "still just a huge gummy photo
 * and i can't choose anything else").
 *
 * ROOT CAUSE THIS FIXES: np-offer-render.js (correctly) hides the native
 * head-price (.bhp), plan-group and .sticky-buy bar for B-E renders via
 * `html.np-offer-live` — their numbers are the CONTROL prices and would
 * contradict the offer panel. But that left a B-E funnel visitor's first
 * mobile viewport with ZERO price or purchase CTA: avatar headline + the
 * avatar-swap packshot fill the fold, and the offer panel sits ~1,400px
 * further down, past the gallery thumbs and the "Real Calm, in motion"
 * video slot. This file restores both affordances WITH THE OFFER'S OWN
 * NUMBERS, read from the same np-offer-config JSON the panel renders from:
 *
 *   1. a sticky bottom bar (mobile <=960px, mirroring .sticky-buy's shape):
 *      offer headline + default-tile price + a "Choose your offer" button
 *      that scrolls the real offer panel into view. Hidden (same principle
 *      as np.js's stickyBuyWanted: never cover a real buy control) while
 *      the panel or the native submit button is on screen.
 *   2. the .buy-head price line (.bhp), un-hidden and rewritten to the
 *      offer's default tile ("$78 · 3 Bottles" / "Buy 2, Get 1 Free") so a
 *      price paints in the first viewport at every width. The un-hide is
 *      gated on data-np-offer-price, which is only ever set here, AFTER the
 *      rewrite — the control numbers can never leak back into view.
 *
 * ADDITIVE ONLY: loaded defer AFTER np-offer-render.js (defer scripts run
 * in tag order, and both wait on the same DOMContentLoaded queue, so
 * np-offer-live/panel state is final before this runs). Touches nothing
 * for control/A/organic sessions — `html.np-offer-live` absent -> no-op,
 * native .bhp + .sticky-buy behave exactly as before. Never edits
 * np-offer-render.js or np-avatar-swap.js logic.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var root = document.documentElement;
    // Only ever act on a session where a B-E panel actually rendered.
    if (!root.classList.contains('np-offer-live')) return;
    var panel = document.querySelector('[data-np-offer-panel]');
    if (!panel) return;

    var variant = window.NP_OFFER || root.getAttribute('data-np-offer') || '';
    var cfg = null;
    try {
      cfg = JSON.parse(document.getElementById('np-offer-config').textContent)[variant];
    } catch (e) { cfg = null; }
    if (!cfg) return;

    // The tile the hidden /cart/add form is already wired to (same index
    // logic as np-offer-render.js renderVariant): default_tile or 0.
    var tile = null;
    if (Array.isArray(cfg.tiles) && cfg.tiles.length) {
      var idx = typeof cfg.default_tile === 'number' ? cfg.default_tile : 0;
      tile = cfg.tiles[idx] || cfg.tiles[0];
    }

    var qtyText = tile
      ? (tile.qty === 1 ? '1 Bottle' : tile.qty + ' Bottles')
      : '';

    /* ---- 2. head price restore (all widths) ---- */
    var bhp = document.querySelector('.buy-head .bhp');
    if (bhp && tile) {
      var hb = bhp.querySelector('[data-headprice-price]') || bhp.querySelector('b');
      if (hb) hb.textContent = tile.price + ' · ' + qtyText;
      var hp = bhp.querySelector('[data-headprice-plan]') || bhp.querySelector('.bhp-plan');
      // 2026-09-01 PM: label with the WIRED tile's own deal (always true for
      // that tile), not the panel headline — the panel header is now the
      // bundle-neutral "Pick your pack" (see np-offer-config.liquid).
      if (hp) hp.textContent = (tile && tile.deal) || cfg.label || cfg.headline || '';
      bhp.setAttribute('data-np-offer-price', variant); // un-hides via np-offer.css
    }

    /* ---- 1. sticky bottom bar (mobile, <=960px via CSS) ---- */
    var bar = document.createElement('div');
    bar.className = 'np-offer-sticky';
    bar.setAttribute('data-np-offer-sticky', variant);

    var left = document.createElement('div');
    left.className = 'np-offer-sticky-l';
    var b = document.createElement('b');
    b.textContent = (tile && tile.deal) || cfg.label || cfg.headline || 'Natures Relax Gummies';
    left.appendChild(b);
    if (tile) {
      var small = document.createElement('small');
      small.textContent = qtyText + ' · ' + tile.price;
      if (tile.compare) {
        var s = document.createElement('s');
        s.textContent = tile.compare;
        small.appendChild(s);
      }
      left.appendChild(small);
    }
    bar.appendChild(left);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'btn np-offer-sticky-btn';
    btn.textContent = 'Choose your offer';
    btn.addEventListener('click', function () {
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    bar.appendChild(btn);
    document.body.appendChild(bar);

    /* ---- 3. submit-label honesty (found during this fix's verification) ----
       Under np-offer-live the native submit still carried the CONTROL label
       ("Start my subscription · $35/mo") while the hidden form is wired to
       the offer's bundle variant — e.g. cell B charges $78 under a $35/mo
       label. Rewrite it to the wired tile's real price, and keep it in sync
       (plus the sticky bar's price line) when the visitor picks a different
       tile or the buy-once line. Delegated listener on the panel — never
       touches np-offer-render.js's own tile handlers. */
    var submitBtn = document.querySelector('[data-buy-submit]');
    var setSubmit = function (price) {
      if (submitBtn) submitBtn.textContent = price ? 'Add to cart · ' + price : 'Add to cart';
    };
    var setBarSmall = function (t) {
      var small = bar.querySelector('small');
      if (!small || !t) return;
      small.textContent = (t.qty === 1 ? '1 Bottle' : t.qty + ' Bottles') + ' · ' + t.price;
      if (t.compare) {
        var s2 = document.createElement('s');
        s2.textContent = t.compare;
        small.appendChild(s2);
      }
    };
    if (tile) setSubmit(tile.price);
    panel.addEventListener('click', function (e) {
      var tEl = e.target.closest('.np-offer-tile');
      if (tEl && tEl.parentElement) {
        var i = Array.prototype.indexOf.call(tEl.parentElement.children, tEl);
        var t = Array.isArray(cfg.tiles) ? cfg.tiles[i] : null;
        if (t) {
          setSubmit(t.price); setBarSmall(t);
          if (t.deal) { b.textContent = t.deal; var hp2 = document.querySelector('.buy-head .bhp [data-headprice-plan]'); if (hp2) hp2.textContent = t.deal;
            var hb2 = document.querySelector('.buy-head .bhp [data-headprice-price]'); if (hb2) hb2.textContent = t.price + ' · ' + (t.qty === 1 ? '1 Bottle' : t.qty + ' Bottles'); }
        }
        return;
      }
      var boEl = e.target.closest('.np-offer-buyonce');
      if (boEl) {
        var m = (boEl.textContent.match(/\$[\d.]+/g) || []).pop();
        setSubmit(m || '');
      }
    });

    // Never cover a control that can already take the order: hide while the
    // offer panel OR the native submit button is on screen. IO threshold 0,
    // tiny and passive; no scroll listener needed.
    var submit = document.querySelector('[data-buy-submit]');
    var onScreen = { panel: false, submit: false };
    var sync = function () {
      if (onScreen.panel || onScreen.submit) bar.classList.remove('show');
      else bar.classList.add('show');
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.target === panel) onScreen.panel = en.isIntersecting;
          if (en.target === submit) onScreen.submit = en.isIntersecting;
        });
        sync();
      }, { threshold: 0 });
      io.observe(panel);
      if (submit) io.observe(submit);
      // First IO callback is async; paint the bar on the next frame so the
      // slide-in transition runs from its translated rest state.
      requestAnimationFrame(function () { requestAnimationFrame(sync); });
    } else {
      bar.classList.add('show'); // ancient fallback: always visible
    }
  });
})();
